import React from "react";
import type { ContentCarouselIntroSlide } from "@/types/content";
import { imageSizeAttributes } from "@/utils/imageSize";
import { fixedCmsImage, responsiveCmsImage } from "@/utils/cmsImage";
import styles from "./ContentCarousel.module.css";

/** The slide's width: the carousel container, 1136px wide in the block grid. */
const SLIDE_SIZES = "(max-width: 1200px) 100vw, 1136px";

interface IntroSlideProps {
  slide: ContentCarouselIntroSlide;
}

export const IntroSlide: React.FC<IntroSlideProps> = ({ slide }) => {
  return (
    <div className={styles.introSlide}>
      {slide.backgroundImage?.url && (
        <>
          <img
            {...responsiveCmsImage(
              slide.backgroundImage.url,
              SLIDE_SIZES,
              slide.backgroundImage.width
            )}
            alt={slide.backgroundImage.altText || ""}
            className={styles.introBg}
          />
          <div className={styles.introOverlay} aria-hidden="true" />
        </>
      )}

      <div className={styles.introContent}>
        {slide.logo?.url && (
          <img
            {...fixedCmsImage(slide.logo.url, { height: 60 })}
            alt={slide.logo.altText || ""}
            className={styles.introLogo}
            {...imageSizeAttributes(slide.logo)}
          />
        )}

        <h2 className={styles.introHeading}>{slide.heading}</h2>

        {slide.subtitle && (
          <p className={styles.introSubtitle}>{slide.subtitle}</p>
        )}

        {slide.ctaButton?.url && (
          <a
            href={slide.ctaButton.url}
            target={slide.ctaButton.target || undefined}
            className={styles.introCtaButton}
          >
            {slide.ctaButton.name}
          </a>
        )}
      </div>
    </div>
  );
};
